import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../shadcn/ui/select";

// Fixed Spacia peer base URLs - the user may only pick between these two environments.
// The path is always /booking.
export const SPACIA_SANDBOX_BASE_URL = "https://api.sandbox.spacia.page/booking";
export const SPACIA_LIVE_BASE_URL = "https://api.spacia.africa/booking";

export const PEER_ENVIRONMENTS = [
  { id: "sandbox", label: "Spacia Sandbox", value: SPACIA_SANDBOX_BASE_URL },
  { id: "live", label: "Spacia Live", value: SPACIA_LIVE_BASE_URL },
];

/**
 * Map a stored/free-text peer URL to one of the two fixed environment URLs
 * (handles both app.* and api.* host variants so editing existing connections
 * pre-selects the correct environment).
 */
export const normalizePeerBaseUrl = input => {
  if (!input) return "";

  let host = "";
  try {
    host = new URL(input).hostname;
  } catch {
    host = String(input).toLowerCase();
  }
  const normalized = host.toLowerCase();

  if (normalized.includes("sandbox") || normalized.includes("staging")) {
    return SPACIA_SANDBOX_BASE_URL;
  }
  if (normalized.includes("spacia.africa") || normalized.includes("spacia.page")) {
    return SPACIA_LIVE_BASE_URL;
  }
  return input;
};

/**
 * PeerBaseUrlField - restricts the peer base URL to a fixed Spacia environment
 * (Sandbox or Live). Always resolves to https://<env>/booking.
 */
const PeerBaseUrlField = ({ value, onChange, placeholder, disabled }) => {
  const selected = PEER_ENVIRONMENTS.some(env => env.value === value) ? value : "";

  return (
    <Select value={selected} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={placeholder || "Select Spacia environment"} />
      </SelectTrigger>
      <SelectContent>
        {PEER_ENVIRONMENTS.map(env => (
          <SelectItem key={env.id} value={env.value}>
            <span className="block">{env.label}</span>
            <span className="block text-xs text-muted-foreground font-mono">{env.value}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default PeerBaseUrlField;
